module.exports = __webpack_public_path__ + "img/apply-success-bg.6ea25bbf.png";